import api, { handleApiError, fetchAllDataRest } from './client';

export const membershipService = {
  createMembership: async (membershipData) => {
    try {
      const payload = {
        userId: membershipData.userId,
        academicYear: membershipData.academicYear,
        amount: membershipData.amount,
        membershipNumber: membershipData.membershipNumber,
        paidDate: membershipData.paidDate ? new Date(membershipData.paidDate).toISOString() : null,
        paymentMethod: membershipData.paidDate ? (membershipData.paymentMethod || 'cash') : null,
        expiryDate: membershipData.expiryDate ? new Date(membershipData.expiryDate).toISOString() : null,
      };

      const response = await api.post('/api/memberships', payload);
      return {
        success: true,
        data: response.data,
        message: 'Tesseramento creato con successo',
      };
    } catch (error) {
      console.error('Create membership error:', error);
      return handleApiError(error, 'Errore nella creazione del tesseramento');
    }
  },

  getUserMemberships: async (userId, page = 1, limit = 5, exportAll = false) => {
    try {
      const url = `/api/memberships/user/${userId}`;
      if (exportAll) {
        return await fetchAllDataRest(url, {}, 'tesseramenti');
      }

      const response = await api.get(url, { params: { page, limit } });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching user memberships:', error);
      return handleApiError(error, 'Errore nel caricamento dei tesseramenti');
    }
  },

  updateMembership: async (id, membershipData) => {
    try {
      const payload = {
        membershipNumber: membershipData.membershipNumber || null,
        amount: membershipData.amount,
        paidDate: membershipData.paidDate ? new Date(membershipData.paidDate).toISOString() : null,
        paymentMethod: membershipData.paidDate ? (membershipData.paymentMethod || 'cash') : null,
        expiryDate: membershipData.expiryDate ? new Date(membershipData.expiryDate).toISOString() : null,
      };

      const response = await api.put(`/api/memberships/${id}`, payload);
      return {
        success: true,
        data: response.data,
        message: 'Tesseramento aggiornato con successo',
      };
    } catch (error) {
      console.error('Update membership error:', error);
      return handleApiError(error, "Errore nell'aggiornamento del tesseramento");
    }
  },

  deleteMembership: async (id) => {
    try {
      await api.delete(`/api/memberships/${id}`);
      return { success: true, message: 'Tesseramento eliminato con successo' };
    } catch (error) {
      console.error('Delete membership error:', error);
      return handleApiError(error, "Errore nell'eliminazione del tesseramento");
    }
  },
};

export default membershipService;
